import api from './apiData.js'

const cmsBundleEndpoint = "api/cms/bundle";

export default {

  getBundle() {
    return api.get(cmsBundleEndpoint);
  }
}
